module.exports = __webpack_public_path__ + "index/img/icon_zhekou.7cecc669.svg";